var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BankAccountForm',{attrs:{"mode":_vm.PAYOUT_METHOD_MODE_ADD,"payout-account":_vm.payoutAccount,"payout-method":_vm.payoutMethod},on:{"success":_vm.handleSuccess,"back":_vm.handleBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }